import { render, staticRenderFns } from "./sign-packet.vue?vue&type=template&id=3aa8459e&scoped=true&"
import script from "./sign-packet.vue?vue&type=script&lang=js&"
export * from "./sign-packet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa8459e",
  null
  
)

export default component.exports